import React, { useEffect, useState } from "react";
import { EdibleOilsInputForm } from "../EdibleOilsInputForm";
import PriceForm from "./PriceForm";
import WheatInputForm from "../Wheat/WheatInputForm";
import { SpiceInputForm } from "../Spices/SpiceInputForm";
import SugarInput from "./SugarInput";
import { MaizeInputForm } from "./MaizeInputForm";
import { PulsesInputForm } from "../Pulses/PulsesInputForm";
import { RiceInputForm } from "./RiceInputForm";
import Sidebar from "../Sidebar";

export const Radio = ({ func, e, c, w, sp, su, m, p, r, val, title }) => {
  return (
    <div class="form-check form-check-inline">
      <input
        class="form-check-input"
        type="checkbox"
        id="inlineCheckbox1"
        checked={val}
        onChange={() => {
          func(e, c, w, sp, su, m, p, r);
        }}
        value="option1"
      />
      <label class="form-check-label" for="inlineCheckbox1">
        {title}
      </label>
    </div>
  );
};

export const CombinedPrice = () => {
  const [edibleOils, setEdibleOils] = useState(false);
  const [cotton, setCotton] = useState(true);
  const [wheat, setWheat] = useState(false);
  const [spice, setSpice] = useState(false);
  const [sugar, setSugar] = useState(false);
  const [maize, setMaize] = useState(false);
  const [pulses, setPulses] = useState(false);
  const [rice, setRice] = useState(false);

  const setter = (e, c, w, sp, su, m, p, r) => {
    setEdibleOils(e);
    setCotton(c);
    setWheat(w);
    setSpice(sp);
    setSugar(su);
    setMaize(m);
    setPulses(p);
    setRice(r);
  };

  return (
    <>
      <div className="sidebar">
        <Sidebar />
      </div>

      <div id="tabler">
        <div></div>

        <Radio
          func={setter}
          title={"Cotton"}
          e={false}
          c={true}
          w={false}
          sp={false}
          su={false}
          m={false}
          p={false}
          r={false}
          val={cotton}
        ></Radio>
        <Radio
          func={setter}
          title={"Edible Oils"}
          e={true}
          c={false}
          w={false}
          sp={false}
          su={false}
          m={false}
          p={false}
          r={false}
          val={edibleOils}
        ></Radio>

        <Radio
          func={setter}
          title={"Wheat"}
          e={false}
          c={false}
          w={true}
          sp={false}
          su={false}
          m={false}
          p={false}
          r={false}
          val={wheat}
        ></Radio>
        <Radio
          func={setter}
          title={"Spice"}
          e={false}
          c={false}
          w={false}
          sp={true}
          su={false}
          m={false}
          p={false}
          r={false}
          val={spice}
        ></Radio>
        <Radio
          func={setter}
          title={"Sugar"}
          e={false}
          c={false}
          w={false}
          sp={false}
          su={true}
          m={false}
          p={false}
          r={false}
          val={sugar}
        ></Radio>
        <Radio
          func={setter}
          title={"Maize"}
          e={false}
          c={false}
          w={false}
          sp={false}
          su={false}
          m={true}
          p={false}
          r={false}
          val={maize}
        ></Radio>
        <Radio
          func={setter}
          title={"Pulses"}
          e={false}
          c={false}
          w={false}
          sp={false}
          su={false}
          m={false}
          p={true}
          r={false}
          val={pulses}
        ></Radio>
        <Radio
          func={setter}
          title={"Rice"}
          e={false}
          c={false}
          w={false}
          sp={false}
          su={false}
          m={false}
          p={false}
          r={true}
          val={rice}
        ></Radio>
      </div>
      {edibleOils && <EdibleOilsInputForm />}
      {cotton && <PriceForm />}
      {wheat && <WheatInputForm />}
      {spice && <SpiceInputForm />}
      {sugar && <SugarInput />}
      {maize && <MaizeInputForm />}
      {pulses && <PulsesInputForm />}
      {rice && <RiceInputForm />}
    </>
  );
};
